<div class="w-full h-full mt-2">

    <div class="flex flex-row items-center justify-end border-b" >
        <button mat-flat-button [color]="'seccondary'" (click)="closeDrawer1()">
            <mat-icon
                class=""
                [svgIcon]="'heroicons_outline:x-mark'"
            ></mat-icon>
        </button>

    </div>
     @if (renderObject) {
            <div class="w-full h-full py-2"   >
                @if (documentUrl) {
                    <object 
                        class="w-full h-full" 
                        [attr.data]="documentUrl" 
                        [attr.type]="documentType">
                    </object>
                }
        </div>
    }      
        
</div>